// extracted by mini-css-extract-plugin
module.exports = {"main":"HomePageStarlink_main__3njgf","starlink__button":"HomePageStarlink_starlink__button__1sljP"};